"use strict";

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _taggedTemplateLiteral = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIntl = require("react-intl");
var _AzertyMailing = _interopRequireDefault(require("./AzertyMailing"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
// === Regex ===
var EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;

// === Couleurs ===
var COLORS = {
  primary: 'rgba(204,2,101,1)',
  // rose foncé (texte dans le formulaire)
  inputBg: 'rgba(255,187,213,1)',
  // rose clair (input)
  textWhite: 'rgba(255,255,255,1)' // texte général
};

// === Styled Components ===
var Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: flex-start; /* \u2B05\uFE0F en haut */\n  width: 100%;\n  padding: 1rem;\n  box-sizing: border-box;\n  color: ", ";\n"])), COLORS.textWhite);
var InnerWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding-top: 3vh; /* l\xE9g\xE8rement moins haut */\n"])));
var Card = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 2.5rem 1rem; /* moins d'espace sur les c\xF4t\xE9s */\n  border-radius: 20px;\n  background-color: transparent;\n  gap : 25px;\n  width: 100%;\n  max-width: 500px; /* un peu plus large */\n  box-sizing: border-box;\n  text-align: center;\n  color: ", ";\n"])), COLORS.textWhite);
var ThankYouCard = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-top : 20px;\n  text-align: center;\n  color: ", ";\n"])), COLORS.textWhite);
var CardTitle = _styledComponents.default.h3(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-family: font, serif;\n  font-size: 28px; /* plus grand */\n  font-weight: 700;\n  margin-bottom: 1.2rem;\n  color: ", ";\n"])), COLORS.textWhite);
var EmailInputField = _styledComponents.default.input(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 360px; /* un peu plus large */\n  height: 40px; /* plus grand */\n  padding: 0.5em;\n  border-radius: 0.5em;\n  border: 2px solid ", ";\n  background-color: ", ";\n  color: ", ";\n  font-family: font, serif;\n  font-size: 15px; /* plus grand */\n  font-weight: 700;\n  text-align: center;\n  margin-bottom: 0.8rem;\n\n  &::placeholder {\n    color: rgba(204,2,101,0.6);\n  }\n\n  &:focus {\n    outline: none;\n    border-color: ", ";\n  }\n"])), COLORS.primary, COLORS.inputBg, COLORS.primary, COLORS.primary);
var WarningText = _styledComponents.default.p(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 0.9rem; /* plus grand */\n  margin-bottom: 1rem;\n  max-width: 450px; /* un peu plus large */\n  text-align: center;\n  line-Height : 30px;\n  color: ", ";\n"])), COLORS.textWhite);
var SendButton = _styledComponents.default.button(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: 160px; /* plus large */\n  height: 45px; /* plus grand */\n  border-radius: 100px;\n  background-color: ", ";\n  color: ", ";\n  font-family: font, serif;\n  font-size: 17px; /* plus grand */\n  font-weight: 700;\n  border: 2px solid ", ";\n  cursor: pointer;\n  margin-bottom: 1rem;\n  transition: opacity 0.2s;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &:hover:not(:disabled) {\n    opacity: 0.85;\n  }\n"])), COLORS.textWhite, COLORS.primary, COLORS.primary);
var StatusMessage = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-size: 0.9rem; /* plus grand */\n  min-height: 1.2rem;\n  margin-top: 0.5rem;\n  color: ", ";\n"])), COLORS.textWhite);

// === Component ===
function SendEmailCell(_ref2) {
  var cell = _ref2.cell,
    project = _ref2.project,
    page = _ref2.page,
    intl = _ref2.intl;
  var _ref3 = (0, _react.useState)(''),
    _ref4 = _slicedToArray(_ref3, 2),
    email = _ref4[0],
    setEmail = _ref4[1];
  var _ref5 = (0, _react.useState)(false),
    _ref6 = _slicedToArray(_ref5, 2),
    isSending = _ref6[0],
    setIsSending = _ref6[1];
  var _ref7 = (0, _react.useState)(null),
    _ref8 = _slicedToArray(_ref7, 2),
    sendStatus = _ref8[0],
    setSendStatus = _ref8[1];
  var _ref9 = (0, _react.useState)(false),
    _ref0 = _slicedToArray(_ref9, 2),
    isSent = _ref0[0],
    setIsSent = _ref0[1];
  var _ref1 = (0, _react.useState)(''),
    _ref10 = _slicedToArray(_ref1, 2),
    title = _ref10[0],
    setTitle = _ref10[1];
  var _ref11 = (0, _react.useState)(''),
    _ref12 = _slicedToArray(_ref11, 2),
    emailPlaceholder = _ref12[0],
    setEmailPlaceholder = _ref12[1];
  var _ref13 = (0, _react.useState)(''),
    _ref14 = _slicedToArray(_ref13, 2),
    sendLabel = _ref14[0],
    setSendLabel = _ref14[1];
  var _ref15 = (0, _react.useState)(''),
    _ref16 = _slicedToArray(_ref15, 2),
    warningText = _ref16[0],
    setWarningText = _ref16[1];
  var _ref17 = (0, _react.useState)(''),
    _ref18 = _slicedToArray(_ref17, 2),
    successMessage = _ref18[0],
    setSuccessMessage = _ref18[1];
  var _ref19 = (0, _react.useState)(''),
    _ref20 = _slicedToArray(_ref19, 2),
    errorMessage = _ref20[0],
    setErrorMessage = _ref20[1];
  var _ref21 = (0, _react.useState)(false),
    _ref22 = _slicedToArray(_ref21, 2),
    showKeyboard = _ref22[0],
    setShowKeyboard = _ref22[1];
  var inputRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    switch (intl.locale) {
      case 'fr':
        setTitle('Envoyer par email');
        setEmailPlaceholder('EMAIL');
        setSendLabel('ENVOYER');
        setWarningText("Attention : votre adresse email est uniquement utilisée pour l'envoi de votre voucher personnel et ne sera pas utilisée à des fins commerciales. La politique de confidentialité de Treeosk est disponible sur le bouton en dessous (Privacy Policy). Aucune donnée n'est partagée avec Belfius.");
        setSuccessMessage('Email envoyé !');
        setErrorMessage("Erreur lors de l'envoi.");
        break;
      case 'nl':
        setTitle('Verstuur per e-mail');
        setEmailPlaceholder('EMAIL');
        setSendLabel('VERSTUREN');
        setWarningText("Opgelet: uw e-mailadres wordt enkel gevraagd voor de verzending van uw persoonlijke voucher en wordt bijgevolg niet gebruikt voor verdere commerciële doeleinden. Het privacycharter van Treeosk vind uw hieronder (Privacy Policy). Er worden geen persoonlijke gegevens uitgewisseld met Belfius.");
        setSuccessMessage('E-mail verzonden!');
        setErrorMessage('Fout bij het verzenden.');
        break;
      case 'en':
      default:
        setTitle('Send by email');
        setEmailPlaceholder('EMAIL');
        setSendLabel('SEND');
        setWarningText('Warning: your email address is only requested for sending your personal voucher and will not be used for further commercial purposes. Treeosk privacy policy: https://www.mytreeosk.com/privacy-policy. No personal data is shared with Belfius.');
        setSuccessMessage('Email sent!');
        setErrorMessage('Error sending email.');
    }
  }, [intl.locale]);
  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
      var response, data, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (e) e.preventDefault();
            if (!(!email.trim() || !EMAIL_REGEX.test(email.trim()) || !(project !== null && project !== void 0 && project.backEndUri))) {
              _context.n = 1;
              break;
            }
            setSendStatus('error');
            return _context.a(2);
          case 1:
            setIsSending(true);
            setSendStatus(null);
            _context.p = 2;
            _context.n = 3;
            return fetch("".concat(project.backEndUri, "/send_email_content"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                cell_id: cell.id,
                pageId: page.id,
                email: email.trim(),
                consent: true,
                terms: true
              })
            });
          case 3:
            response = _context.v;
            if (response.ok) {
              _context.n = 5;
              break;
            }
            _context.n = 4;
            return response.json().catch(function () {
              return {};
            });
          case 4:
            data = _context.v;
            throw new Error(data.error || 'Upload failed');
          case 5:
            setSendStatus('success');
            setIsSent(true);
            _context.n = 7;
            break;
          case 6:
            _context.p = 6;
            _t2 = _context.v;
            console.error('Send email error:', _t2);
            setSendStatus('error');
          case 7:
            _context.p = 7;
            setIsSending(false);
            return _context.f(7);
          case 8:
            return _context.a(2);
        }
      }, _callee, null, [[2, 6, 7, 8]]);
    }));
    return function handleSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var canSubmit = email.trim() && EMAIL_REGEX.test(email.trim()) && !isSending;

  // === Thank you view ===
  if (isSent) {
    return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(InnerWrapper, null, /*#__PURE__*/_react.default.createElement(ThankYouCard, null, /*#__PURE__*/_react.default.createElement(CardTitle, null, successMessage), /*#__PURE__*/_react.default.createElement("p", {
      style: {
        textAlign: 'center',
        fontSize: '1.8rem'
      }
    }, intl.locale === 'nl' ? 'Bedankt voor uw deelname!' : intl.locale === 'fr' ? 'Merci pour votre participation !' : 'Thank you for your subscription!'))));
  }

  // === Form view ===
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(InnerWrapper, null, /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(Card, null, /*#__PURE__*/_react.default.createElement(CardTitle, null, title), /*#__PURE__*/_react.default.createElement(EmailInputField, {
    ref: inputRef,
    type: "text",
    value: email,
    placeholder: emailPlaceholder,
    readOnly: true,
    autoComplete: "off",
    inputMode: "none",
    onClick: function onClick() {
      return setShowKeyboard(true);
    },
    onTouchStart: function onTouchStart() {
      return setShowKeyboard(true);
    }
  }), showKeyboard && /*#__PURE__*/_react.default.createElement(_AzertyMailing.default, {
    input: email,
    setInput: setEmail,
    project: project,
    setVisible: setShowKeyboard,
    anchorRef: inputRef
  }), /*#__PURE__*/_react.default.createElement(WarningText, null, warningText), /*#__PURE__*/_react.default.createElement(SendButton, {
    type: "submit",
    disabled: !canSubmit
  }, isSending ? '...' : sendLabel), /*#__PURE__*/_react.default.createElement(StatusMessage, null, sendStatus === 'error' && errorMessage)))));
}
var _default = exports.default = (0, _reactIntl.injectIntl)(SendEmailCell);